import React from 'react';

import i18n from '../../i18n';

// @mui
import { FormControlLabel, Checkbox } from '@mui/material';

export default class DialogEnableField extends React.Component {
    handleCheckboxChanged(event, value) {
        this.props.onChange(event.target.id, value);
    }

    render() {
        // field, value, cache, onChange
        const { field, value } = this.props;
        // `<label>Enabled` lets a column say "Enabled" in the editor and something
        // shorter in the grid; most columns have no such key, so the plain label
        // stands in rather than the raw key.
        let translatedName = i18n.t([`columns.${field.label}Enabled`, `columns.${field.label}`]);
        // As DialogCheckboxField: `disabled` carries the template lock FormField
        // computes, `onlyRead` a page's own. `lockedOnEdit`, a function, locks an
        // existing row's flag that a separate permission governs, and is asked at
        // render: DialogAbstract keeps the head it mounted with.
        const onlyRead =
            !!field.onlyRead ||
            !!this.props.disabled ||
            (this.props.mode === 'edit' && Boolean(field.lockedOnEdit?.()));

        return (
            <FormControlLabel
                key={field.label}
                control={
                    <Checkbox
                        disabled={onlyRead}
                        id={field.id}
                        checked={value || false}
                        onChange={(event, checked) =>
                            this.handleCheckboxChanged(event, checked)
                        }
                    />
                }
                label={translatedName}
            />
        );
    }
}
